import { UPDATE_QID } from "../../actions/QueryBuilder/actionConstants";

const qidReducer = (state = "", action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  qid
		 * }
		 */
		case UPDATE_QID:
			return action.qid;
		default:
			return state;
	}
};

export default qidReducer;
